import { ChangeDetectorRef, DestroyRef, inject, Pipe, PipeTransform } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Resource } from 'app/shared/acl/acl.model';
import { AclService } from 'app/shared/acl/acl.service';


// type AclResource<T extends Record<string, unknown>> = { [K in keyof T as (T[K] extends Resource | null | undefined ? K : never)]: unknown };


@Pipe({
    name: 'acl',
    pure: false,
})
export class AclPipe implements PipeTransform {

    private acl = inject(AclService);

    private cdr = inject(ChangeDetectorRef);

    private destroyRef = inject(DestroyRef);

    ngOnInit() {
        this.acl.allowed.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => this.cdr.detectChanges());
    }

    // transform<T extends Record<string, unknown>>(items: T[], key: keyof AclResource<T>) {
    transform<T>(items: T[], key: string) {
        return items.filter(i => this.acl.can((i as any)[key] as Resource));
    }
}
